import React, { useMemo } from "react";
import { useAPI } from "../../lib/common";
import Box from "@material-ui/core/Box";
import {
  createInstance,
  getTemplateTranslation,
} from "../../Providers/TemplateInstanceProvider";
import i18next from "i18next";
import { usePriceList } from "../providers/PriceListProvider";
import useTemplate from "../../hooks/useTemplate";
import DrawTemplate from "../../components/Template/DrawTemplate";
import { Trans, useTranslation } from "react-i18next";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Container from "@material-ui/core/Container";
import Button from "@material-ui/core/Button";
import { advertFormatCurrency } from "../../utils";
import PointBurst from "./PointBurst";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { PageHeader } from "./MobilePage";
import useIsMobileDevice from "../../hooks/useIsMobileDevice";
import { HTMLCarousel, HTMLCarouselItem } from "./HTMLCarousel";
import useRoutes, { getLinkComponentAttributes } from "../hooks/useRoutes";
import { useShoppingCart } from "../providers/ShoppingCartProvider";

const useStyles = makeStyles((theme) => ({
  promotedProductsList: {
    listStyle: "none",
    margin: 0,
    padding: 0,
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gridGap: theme.spacing(2),
    "& > li": {
      display: "flex",
    },
  },
  promotedItem: {
    position: "relative",
    backgroundColor: "red",
  },
  templateContainer: {
    position: "relative",
    height: "168px",
    width: "104px",
    display: "flex",
    justifyContent: "center",
  },
  templateOuterContainer: {
    backgroundColor: theme.palette.primary.light,
    width: "120px",
    height: "184px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: theme.spacing(2),
  },
  pricesContainer: {
    display: "flex",
    flexDirection: "column",
    marginTop: "40px",
    "& h4": {
      fontSize: "15px",
      color: theme.palette.primary.dark,
      textAlign: "right",
      fontWeight: 500,
      whiteSpace: "nowrap",
    },
    "& h6": {
      fontSize: "12px",
      color: "#2a2a2a",
      textAlign: "right",
      fontWeight: 400,
    },
  },
  priceText: {
    fontSize: "24px",
    textAlign: "right",
    lineHeight: "28px",
  },
  oldPriceText: {
    fontSize: "12px",
    textDecoration: "line-through",
    textAlign: "right",
    color: "rgba(0, 0, 0, 0.5)",
  },
  priceFromText: {
    fontSize: "10px",
    textAlign: "right",
    lineHeight: "12px",
  },
  priceContainer: {
    marginBottom: theme.spacing(1),
  },
  rebatedPriceText: {
    color: theme.palette.secondary.main,
    fontWeight: 500,
    fontSize: "15px",
    textAlign: "right",
  },
  promotedProductsCard: {
    overflow: "visible",
    marginTop: "40px",
    flexGrow: 1,
    [theme.breakpoints.down("xs")]: {
      minWidth: "70vw",
    },
  },
  pointBurstContainer: {
    height: "60px",
    /*
        display: 'flex',
        justifyContent: 'flex-end',
         */
    top: "-45px",
    right: "68px",
    position: "absolute",
  },
  bestSellerContent: {
    fontSize: "10px",
    whiteSpace: "normal",
    lineHeight: "12px",
  },
  promotedProductsBox: {
    position: "relative",
  },
}));

export default () => {
  const isMobile = useIsMobileDevice();

  if (isMobile) {
    return <PromotedProductsMobile />;
  } else {
    return <PromotedProductsDesktop />;
  }
};

const PromotedProductsMobile = () => {
  const classes = useStyles();
  const [promotedProducts, loading] = useAPI("/api/webshop/promoted-products");
  if (!promotedProducts || promotedProducts.length == 0) {
    return null;
  }

  return (
    <Container disableGutters={true}>
      <PageHeader>
        <Trans>Other popular products</Trans>
      </PageHeader>

      <HTMLCarousel>
        {promotedProducts.map((promotedProduct, idx) => {
          return (
            <HTMLCarouselItem>
              <PromotedProduct key={idx} promotedProduct={promotedProduct} />
            </HTMLCarouselItem>
          );
        })}
      </HTMLCarousel>
    </Container>
  );
};

const PromotedProductsDesktop = () => {
  const classes = useStyles();
  const [promotedProducts, loading] = useAPI("/api/webshop/promoted-products");
  if (!promotedProducts || promotedProducts.length == 0) {
    return null;
  }

  return (
    <Container maxWidth="lg">
      <PageHeader>
        <Trans>Other popular products</Trans>
      </PageHeader>
      <ul className={classes.promotedProductsList}>
        {promotedProducts.map((promotedProduct, idx) => {
          return (
            <li>
              <PromotedProduct key={idx} promotedProduct={promotedProduct} />
            </li>
          );
        })}
      </ul>
    </Container>
  );
};

const getReadMoreLink = (promotedProduct, routes, product) => {
  console.log("Promoted product", promotedProduct);
  if (promotedProduct.type == "category") {
    if (product.producttype == 2) {
      const path = {
        path: "products.cards",
        variables: { type: "cards" },
      };
      return getLinkComponentAttributes(path, routes);
    } else if (product.producttype == 1) {
      const path = {
        path: "products.calendars",
        variables: { type: "calendars" },
      };
      return getLinkComponentAttributes(path, routes);
    } else {
      const path = {
        path: "products.photogifts.category",
        variables: {
          category: promotedProduct.category,
          type: "photogifts",
        },
      };
      return getLinkComponentAttributes(path, routes);
    }
  } else {
    // Use calendar as we might not have a category?
    let routePath = "products.categories.category.create";
    let type = "photogifts";
    if (promotedProduct.template.type == "CALENDAR") {
      routePath = "products.calendars.create";
      type = "calendars";
    }
    if (promotedProduct.template.type == "CARD") {
      type = "cards";
    }
    console.log("Promoted product", promotedProduct);
    const path = {
      path: routePath,
      variables: {
        category: promotedProduct.category,
        type: type,
        templateUuid: promotedProduct.template.uuid,
        productUuid: promotedProduct.product.uuid,
      },
    };
    return getLinkComponentAttributes(path, routes);
  }
};

const PromotedProduct = ({ promotedProduct }) => {
  const classes = useStyles();
  const { getProductByUuid } = usePriceList();
  const routes = useRoutes();
  const { qualifyForPromotedPrice } = useShoppingCart();
  const { t } = useTranslation();

  const product = useMemo(() => {
    return getProductByUuid(promotedProduct.product.uuid);
  }, [promotedProduct]);

  const pointBurstColor =
    qualifyForPromotedPrice && promotedProduct.rebatedPrice
      ? "secondary"
      : "primary.dark";
  const pointBurstText =
    qualifyForPromotedPrice && promotedProduct.rebatedPrice
      ? t("Special offer")
      : t("Best seller");

  const link = getReadMoreLink(promotedProduct, routes, product);
  console.log("Promoted product link", link);

  return (
    <Card classes={{ root: classes.promotedProductsCard }}>
      <CardContent>
        <Box
          display="flex"
          justifyContent="space-between"
          className={classes.promotedProductsBox}
        >
          <div className={classes.templateOuterContainer}>
            <div className={classes.templateContainer}>
              <TemplateContainer promotedProduct={promotedProduct} />
            </div>
          </div>
          <div className={classes.pricesContainer}>
            <div className={classes.pointBurstContainer}>
              <PointBurst
                size={60}
                variant={pointBurstColor}
                content={
                  <div className={classes.bestSellerContent}>
                    {pointBurstText}
                  </div>
                }
              ></PointBurst>
            </div>
            <Box flexGrow={1}>
              <h4>{promotedProduct.product.name}</h4>
              <h6>
                {getTemplateTranslation(
                  promotedProduct.template.names,
                  i18next.language,
                )}
              </h6>
            </Box>

            <Price promotedProduct={promotedProduct} product={product} />

            <Box display="flex" width="100%" justifyContent="flex-end">
              <Button variant="contained" color="primary" {...link}>
                <Trans>View product</Trans>
              </Button>
            </Box>
          </div>
        </Box>
      </CardContent>
    </Card>
  );
};

const Price = ({ promotedProduct, product }) => {
  const { qualifyForPromotedPrice } = useShoppingCart();

  const classes = useStyles();
  if (!product) {
    return null;
  }

  const pp = product.productprices;

  console.log("Promoted product", promotedProduct);

  if (qualifyForPromotedPrice && promotedProduct.rebatedPrice) {
    return (
      <div className={classes.priceContainer}>
        <div className={classes.oldPriceText}>
          {advertFormatCurrency(pp[pp.length - 1].price)}
        </div>
        <div className={classes.rebatedPriceText}>
          {advertFormatCurrency(promotedProduct.rebatedPrice)}
        </div>
      </div>
    );
  } else if (product.productprices.length > 1) {
    return (
      <div className={classes.priceContainer}>
        <div className={classes.priceFromText}>
          <Trans>Price from</Trans>
        </div>
        <div className={classes.priceText}>
          {advertFormatCurrency(pp[pp.length - 1].price)}
        </div>
      </div>
    );
  }
  return (
    <div className={classes.priceContainer}>
      <div className={classes.priceText}>
        {advertFormatCurrency(pp[0].price)}
      </div>
    </div>
  );
};

const TemplateContainer = ({ promotedProduct }) => {
  const [template] = useTemplate(promotedProduct.template.uuid);
  const { templateData } = promotedProduct;

  const [templateInstance, size] = useMemo(() => {
    if (!template) {
      return [null, null];
    }

    return [
      createInstance(template, templateData.userResources, templateData.year),
      {
        width: 110,
        height: 150,
      },
    ];
  }, [promotedProduct, template]);

  if (!templateInstance) {
    return null;
  }

  return (
    <>
      <DrawTemplate templateInstance={templateInstance} containerSize={size} />
    </>
  );
};
